﻿package com.mgacreative.hotel.feature.pricing.domain

data class PricingRule(val name: String, val multiplier: Double)

data class RoomTypePrice(
    val id: String,
    val typeName: String,
    val basePrice: Double,
    var currentPrice: Double,
    val suggestedPrice: Double,
    val appliedRules: List<String>
)

class PricingEngine {
    
    // Acceptance Criteria: Fiyat önerisi doluluk ve sezon verisine göre tutarlı şekilde değişiyor
    fun calculateSuggestion(basePrice: Double, occupancyRate: Double, isHighSeason: Boolean): Pair<Double, List<String>> {
        var multiplier = 1.0
        val rulesApplied = mutableListOf<String>()

        // Yüksek doluluk kuralı (> %80)
        if (occupancyRate > 0.80) {
            multiplier *= 1.15 // +15%
            rulesApplied.add("Yüksek Doluluk (+%15)")
        } else if (occupancyRate < 0.30) {
            multiplier *= 0.90 // -10%
            rulesApplied.add("Düşük Doluluk (-%10)")
        }

        // Sezon kuralı
        if (isHighSeason) {
            multiplier *= 1.20 // +20%
            rulesApplied.add("Yüksek Sezon (+%20)")
        } else {
            multiplier *= 0.90 // -10%
            rulesApplied.add("Düşük Sezon (-%10)")
        }

        val suggested = basePrice * multiplier
        return Pair(suggested, rulesApplied)
    }
}

